// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__CgWfK","colMin":"styles_colMin__1861D","colCheckbox":"styles_colCheckbox__Nag6a"};